export const backToTopText = 'Back to top';
